var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11V5C3 3.89543 3.89543 3 5 3H15C16.1046 3 17 3.89543 17 5V11C17 12.1046 16.1046 13 15 13H5C3.89543 13 3 12.1046 3 11Z",
    stroke: "#378440",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.22266L9.14013 8.14653C9.68412 8.40557 10.3159 8.40557 10.8599 8.14653L17 5.22266",
    stroke: "#378440",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16V17.2308C8 17.7831 8.44772 18.2308 9 18.2308H10.6594C11.0851 18.2308 11.4641 18.5003 11.6039 18.9023L11.8622 19.6452C12.0908 20.3024 12.904 20.5311 13.4416 20.0894L15.427 18.4581C15.6059 18.3111 15.8303 18.2308 16.0618 18.2308H20C20.5523 18.2308 21 17.7831 21 17.2308V10C21 9.44772 20.5523 9.00001 20 9V9",
    stroke: "#378440",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.4ca526d5e43c5919dae0721802734b07.svg";
export { ForwardRef as ReactComponent };